var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarlibraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57143 0C1.15313 0 0 1.12109 0 2.5V17.5C0 18.8789 1.15313 20 2.57143 20H17.3571C17.7107 20 18 19.7188 18 19.375C18 19.0312 17.7107 18.75 17.3571 18.75H16.7143V16.1445C17.4616 15.8867 18 15.1914 18 14.375V1.875C18 0.839844 17.1362 0 16.0714 0H2.57143ZM15.4286 16.25V18.75H2.57143C1.86027 18.75 1.28571 18.1914 1.28571 17.5C1.28571 16.8086 1.86027 16.25 2.57143 16.25H15.4286ZM2.57143 15C2.10134 15 1.66339 15.1211 1.28571 15.3359V2.5C1.28571 1.80859 1.86027 1.25 2.57143 1.25H3.85714V15H2.57143ZM5.14286 15V1.25H16.0714C16.425 1.25 16.7143 1.53125 16.7143 1.875V14.375C16.7143 14.7188 16.425 15 16.0714 15H5.14286ZM7.07143 5.625C7.07143 5.96875 7.36071 6.25 7.71429 6.25H14.1429C14.4964 6.25 14.7857 5.96875 14.7857 5.625C14.7857 5.28125 14.4964 5 14.1429 5H7.71429C7.36071 5 7.07143 5.28125 7.07143 5.625ZM7.07143 9.375C7.07143 9.71875 7.36071 10 7.71429 10H14.1429C14.4964 10 14.7857 9.71875 14.7857 9.375C14.7857 9.03125 14.4964 8.75 14.1429 8.75H7.71429C7.36071 8.75 7.07143 9.03125 7.07143 9.375Z",
    fill: "#008CB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarlibraryIcon);
export default __webpack_public_path__ + "static/media/sidebarlibrary_icon.a4ed09ddebe31906a5edfc56b93542dd.svg";
export { ForwardRef as ReactComponent };